import { useCallback, useEffect, useState } from "react";
import { DEVICE_MARKET_URL_KEY, MARKET_URL_KEY } from "../constants";
import { useSearchParamsConfig } from "./useSearchParamsConfig";
/**
 * Hook for filtering list and managing popup display
 */
export const useCountryDisplay = (initialList = [], enabledData) => {
    const [popupOpen, setPopupOpen] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [filteredList, setFilteredList] = useState([]);
    const { search: queryString, isDeviceSource, noGeo, deviceCountry, userCountry } = useSearchParamsConfig();
    const closePopup = useCallback(() => setPopupOpen(false), []);
    useEffect(() => {
        const list = initialList.reduce((acc, item) => {
            const config = enabledData.find((e) => e.code === item.countryCode);
            const urlKey = isDeviceSource ? DEVICE_MARKET_URL_KEY : MARKET_URL_KEY;
            const url = config?.data[urlKey];
            if (url) {
                acc.push({ ...item, url: `${url}${queryString}` });
            }
            return acc;
        }, []);
        setFilteredList(list);
    }, [initialList, enabledData, isDeviceSource, queryString]);
    useEffect(() => {
        if (!isDeviceSource || noGeo)
            return;
        if (deviceCountry && userCountry && deviceCountry !== userCountry) {
            const userConfig = enabledData.find((dataItem) => dataItem.code === userCountry);
            const deviceConfig = enabledData.find((dataItem) => dataItem.code === deviceCountry);
            const userFlag = initialList.find((listItem) => listItem.countryCode === userCountry)?.fileReference || "";
            setPopupData({
                popupIpUrl: `${userConfig?.data.DeviceRegistrationUrl}${queryString}`,
                popupPurchaseUrl: `${deviceConfig?.data.DeviceRegistrationUrl}${queryString}`,
                purchaseLocationName: deviceCountry,
                ipLocationName: userCountry,
                flagUrl: userFlag,
            });
            setPopupOpen(true);
        }
    }, [initialList, enabledData, deviceCountry, userCountry, isDeviceSource, noGeo, queryString]);
    return { filteredList, popupOpen, popupData, closePopup };
};
//# sourceMappingURL=useCountryDisplay.js.map